import React from "react";
import { Routes, Route } from "react-router-dom";
import ProfileLayout from "../components/Profile/ProfileLayout/ProfileLayout";
import ProfileHome from "../components/Profile/ProfileHome/ProfileHome";
import ProfileMenu from "../components/Profile/ProfileMenu/ProfileMenu";
import BankHome from "../components/Bank/BankHome/BankHome";
import { dashboardUrl } from "../components/utils/constants";
import SelectPlan from "../components/SelectPlan/SelectPlan";
import DocVerificationHome from "../components/DocumentVerification/DocVerificationHome/DocVerificationHome";
import ESignHome from "../components/ESign/ESignHome/ESignHome";
import VideoVerification from "../components/VideoVerification/VideoVerification";
import Profiler from "../components/Profiler/Profiler";
import EsignKra from "../components/ESign/ESignKra/ESignKra";
import PersoanlInfo from "../components/Registration/PersonalInformation/PersonalInfo";
// import { dashboardUrl } from "../components/utils/constants";
// import SelectPlan from "../components/SelectPlan/SelectPlan";
// import DocVerificationHome from "../components/DocumentVerification/DocVerificationHome/DocVerificationHome";
// import ESignHome from "../components/ESign/ESignHome/ESignHome";
// import VideoVerification from "../components/VideoVerification/VideoVerification";
// import Profiler from "../components/Profiler/Profiler";
import InstanHelp from "../components/InstantHelp/InstantHelp";
import DematSelection from "../components/DematSelection/DematSelection";
import KraAuthenticateHome from "../components/KRAAuthenticate/KraAuthenticateHome";

const DashboardRoutes: React.FC = () => {
  return (
    <Routes>
      <Route
        path={dashboardUrl.profile}
        element={
          <InstanHelp panPageFlag={false}>
            <ProfileLayout>
              <ProfileHome />
            </ProfileLayout>
          </InstanHelp>
        }
      />

      <Route
        path={dashboardUrl.ipv}
        element={
          <InstanHelp panPageFlag={false}>
            <ProfileLayout>
              <VideoVerification />
            </ProfileLayout>
          </InstanHelp>
        }
      />

      <Route
        path={dashboardUrl.doc}
        element={
          <InstanHelp panPageFlag={false}>
            <ProfileLayout>
              <DocVerificationHome />
            </ProfileLayout>
          </InstanHelp>
        }
      />

      <Route
        path={dashboardUrl.demat}
        element={
          <InstanHelp panPageFlag={false}>
            <ProfileLayout>
              <DematSelection />
            </ProfileLayout>
          </InstanHelp>
        }
      />

      <Route
        path={dashboardUrl.bank}
        element={
          <InstanHelp panPageFlag={false}>
            <ProfileLayout>
              <BankHome />
            </ProfileLayout>
          </InstanHelp>
        }
      />

      <Route
        path={dashboardUrl.plan}
        element={
          <InstanHelp panPageFlag={false}>
            <ProfileLayout>
              <SelectPlan />
            </ProfileLayout>
          </InstanHelp>
        }
      />

      <Route
        path={dashboardUrl.profiler}
        element={
          <ProfileLayout>
            <Profiler />
          </ProfileLayout>
        }
      />

      <Route
        path={dashboardUrl.eSign}
        element={
          <InstanHelp panPageFlag={false}>
            <ProfileLayout>
              <ESignHome />
            </ProfileLayout>
          </InstanHelp>
        }
      />

      <Route
        path={dashboardUrl.authenticate}
        element={
          <InstanHelp panPageFlag={false}>
            <ProfileLayout>
              <KraAuthenticateHome />
            </ProfileLayout>
          </InstanHelp>
        }
      />

      <Route
        path={dashboardUrl.personalIfo}
        element={
          <InstanHelp panPageFlag={false}>
            <ProfileLayout>
              <PersoanlInfo />
            </ProfileLayout>
          </InstanHelp>
        }
      />

      <Route path={dashboardUrl.menu} element={<ProfileMenu />} />
    </Routes>
  );
};

export default DashboardRoutes;
